import AreaInfo from './AreaInfo';

export default AreaInfo;
